import { IconChevronLeft } from '../../icons'

interface ProgressIndicatorProps {
    step: number
    total: number
    stepText: string[]
    onBack: () => void
}

export function ProgressIndicator({
    step,
    total,
    stepText,
    onBack,
}: ProgressIndicatorProps) {
    return (
        <header className='flex justify-between items-start mb-12'>
            <button
                onClick={onBack}
                className='flex items-center text-gray font-sans'>
                <IconChevronLeft />
                <span className='ml-1'>Back</span>
            </button>
            <StepIndicator
                text={stepText[step - 1]}
                step={step}
                total={total}
            />
        </header>
    )
}

interface StepIndicatorProps {
    text?: string
    step: number
    total: number
}

function StepIndicator({ text, step, total }: StepIndicatorProps) {
    return (
        <div className='text-right'>
            <div className='text-sm uppercase text-gray3'>
                {step}/{total}
            </div>
            {text && <div className='font-sans text-gray'>{text}</div>}
        </div>
    )
}
